import PassSecurity from './PassSecurity';

export default PassSecurity;
